import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UploadRadiologyReportService } from 'src/app/services/upload-radiology-report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-upload-radiology-report',
  templateUrl: './add-upload-radiology-report.component.html',
  styleUrls: ['./add-upload-radiology-report.component.css'],
})
export class AddUploadRadiologyReportComponent implements OnInit {
  id = 0;
  imageUrl: string;
  isSuccess = false;
  uploadProgress: number = 0;
  constructor(
    private uploadRadiolgyReportService: UploadRadiologyReportService,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });
  }

  mriFrm = this.fb.group({
    RadiologyReportImage: [''],
  });

  get RadiologyReportImage() {
    return this.mriFrm.get('RadiologyReportImage');
  }

  image(e) {
    let formData = new FormData();
    let files = e.target.files;
    formData.append('file', files[0], files[0].name);

    this.uploadRadiolgyReportService.imageUpload(formData).subscribe(
      (res) => {
        let stImg = environment.imgurl + res['path'];
        this.imageUrl = `<p><img src="${stImg}"/></p>`;
      },
      (err) => console.log(err)
    );
    //   (res: HttpEvent<any>) => {
    //     if (res.type === HttpEventType.UploadProgress) {
    //       this.uploadProgress = Math.round((100 * res.loaded) / res.total);
    //     } else if (res.type === HttpEventType.Response) {
    //       let stImg = environment.imgurl + res['path'];
    //       // this.imageUrl = stImg
    //       this.imageUrl = `<p><img src="${stImg}"/></p>`;
    //       this.uploadProgress = 100;
    //     }
    //   },
    //   ({ error }) => {
    //     console.log(error);
    //   }
    // );
  }

  formSubmit() {
    let RadiologyReportImage = this.mriFrm.value['RadiologyReportImage'];

    let body = {
      PatientId: this.id,
      RadiologyReportImage: this.imageUrl,
    };
    // console.log(body);
    this.uploadRadiolgyReportService
      .registerUploadRadiologyReport(body)
      .subscribe((res) => {
        this.isSuccess = true;
        this.mriFrm.reset();
      });
  }
}
